export const onAddProp = (id, dist) => ({
  widget: 'models',
  type: 'onAddProp',
  payload: { id, dist },
})



// WEBPACK FOOTER //
// ./src/models/actions/onAddProp.js